import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FolderIcon, HomeIcon, UsersIcon } from "@heroicons/react/24/outline";
import { BellIcon } from "lucide-react";

const navigation = [
  { name: "Template", href: "/dashboard/configure/template", icon: HomeIcon },
  {
    name: "Require Fields",
    href: "/dashboard/configure/requirefields",
    icon: FolderIcon,
  },
  { name: "Workflow", href: "/dashboard/configure/workflow", icon: UsersIcon },
  {
    name: "Twilio Setup",
    href: "/dashboard/configure/twilio",
    icon: FolderIcon,
  },
  // {
  // 	name: "PMS Integration",
  // 	href: "/dashboard/configure/pms",
  // 	icon: FolderIcon,
  // },
  //   {
  //     name: "Platform Linking",
  //     href: "/dashboard/configure/platform-linking",
  //     icon: FolderIcon,
  //   },
  // {
  //   name: "Notification",
  //   href: "/dashboard/configure/notification",
  //   icon: BellIcon,
  // },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ConfigureSide() {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <div>
        {/* Sidebar for all screen sizes */}
        <div className="inset-y-0 z-50 flex w-full lg:w-72 flex-col">
          {/* Sidebar component */}
          <div className="flex grow flex-col gap-y-3 sm:gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-3 sm:px-4 lg:px-6 pt-3 sm:pt-4">
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-5 sm:gap-y-7">
                <li>
                  <ul role="list" className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        <Link
                          to={item.href}
                          className={classNames(
                            currentPath === item.href
                              ? "bg-gray-50 text-indigo-600"
                              : "text-gray-700 hover:bg-gray-50 hover:text-indigo-600",
                            "group flex gap-x-2 sm:gap-x-3 rounded-md p-2 text-xs sm:text-sm font-semibold leading-6"
                          )}
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
